import { createContext, FC, PropsWithChildren } from 'react'

import { useGlobalQuery } from '../graphql'

const Context = createContext<{
  seo: (SeoFragment | null)[]
  socials: (LinkFragment | null)[]
}>({ seo: [], socials: [] })

const Seo: FC<PropsWithChildren> = ({ children }) => {
  const { data } = useGlobalQuery()
  return (
    <Context.Provider value={{ socials: data?.global?.socials ?? [], seo: data?.global?.seo ?? [] }}>
      {children}
    </Context.Provider>
  )
}
export { Context }
export default Seo
